import { useState } from 'react';
import { toast } from 'sonner';
import { Meta } from '@/components/common';
import { LoginForm, MfaForm } from '@/components/features/auth';
import { AuthLayout } from '@/components/layout';
import { APP } from '@/config';
import { ERRORS } from '@/constants';
import type { MfaChallenge } from '@/types';

/**
 * Signing in, both steps.
 *
 * One route rather than two, because the challenge only exists in memory: it is
 * single-use and short-lived, and a `/login/mfa` URL would be a page broken on
 * reload and bookmarkable into a dead end. Held in state, a reload starts over.
 */
export function LoginPage() {
  const [challenge, setChallenge] = useState<MfaChallenge | null>(null);

  return (
    <>
      <Meta title="Sign in" description="NuDent staff console." />

      <AuthLayout
        title={
          challenge
            ? challenge.setup
              ? 'Set up two-factor authentication'
              : 'Two-factor verification'
            : `Sign in to ${APP.name}`
        }
        description={
          challenge ? undefined : 'Staff accounts only. Customers sign in at www.nudent.ai.'
        }
      >
        {challenge ? (
          <MfaForm
            challenge={challenge}
            onExpired={() => {
              setChallenge(null);
              toast.error(ERRORS.mfaExpired);
            }}
            onBack={() => {
              setChallenge(null);
            }}
          />
        ) : (
          <LoginForm onChallenge={setChallenge} />
        )}
      </AuthLayout>
    </>
  );
}
